import { useState } from "react"
import { coreRequest } from "services/requests"

const prefix = "auth"
const sendRequest = coreRequest.sendRequest

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)

  const authenticateWithUsernamePassword = async ({ email, password }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/authenticate`,
      body: { username: email, password },
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const authenticateWithExternalProvider = async ({
    externalProviderUserId,
    token,
    provider,
  }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/authenticate/externalProvider`,
      body: { externalProviderUserId, token, provider },
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const createExternalAccount = async ({
    externalProviderUserId,
    token,
    provider,
    givenName,
    familyName,
    username,
    userOrigin,
    groupId,
    b2CBranchId,
    languageId,
    languageToLearn,
    pictograms,
  }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `externalProviders/createAccount`,
      body: {
        externalProviderUserId,
        token,
        provider,
        givenName,
        familyName,
        username,
        userOrigin,
        groupId,
        languageId,
        languageToLearn,
        b2CBranchId,
        pictograms,
      },
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const authenticateWithQRToken = async (qrToken) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/authenticate/token`,
      body: qrToken,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const getPictogramOptions = async (languageId = 2) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/getPictogramOptions/${languageId}`,
      body: {},
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const authenticateWithPictograms = async (payload) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/authenticate/pictograms`,
      body: payload,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const validateCode = async (code) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/validateCode/${code}`,
      method: "get",
    })
    setIsFetching(false)
    return response
  }

  const verifyUser = async ({ username }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/passwordRecovery/verifyUser`,
      body: { username },
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const contactSupport = async (payload) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/passwordRecovery/contact`,
      body: payload,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const sendRecoveryEmail = async (payload) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/passwordRecovery/sendEmail`,
      body: payload,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const checkCode = async (payload) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/passwordRecovery/checkCode`,
      body: payload,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const setPassword = async (payload) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/passwordRecovery/setPassword`,
      body: payload,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const getWebToken = async (page = "games", reference = "") => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/webToken?page=${page}&reference=${reference}`,
      body: {},
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  return {
    authenticateWithUsernamePassword,
    authenticateWithExternalProvider,
    createExternalAccount,
    authenticateWithQRToken,
    getPictogramOptions,
    authenticateWithPictograms,
    validateCode,
    verifyUser,
    contactSupport,
    sendRecoveryEmail,
    checkCode,
    setPassword,
    getWebToken,
    isFetching,
  }
}

export default useApi
